export enum AdminRoutes {
  root = 'admin',
  organizations = 'organizations',
  profiles = 'profiles',
  imports = 'imports',
  compliance = 'compliance_queue',
  status = 'status',
  tenDLC = '10DLC',
  tollFree = 'toll-free',
  pricingCalculator = 'pricing_calculator',
  customPrices = 'custom_prices',
  customPayments = 'custom_payments',
  create = 'create',
  numbers = 'numbers',
  restrictedWords = 'restricted-words',
}
